const e = "_textContainer_1yvje_1", t = "_closeButton_1yvje_13", o = "_inverted_1yvje_32", n = "_root_1yvje_57", s = "_leftIcon_1yvje_70", _ = "_is2Liner_1yvje_80", i = "_alignTop_1yvje_87", r = "_flashMessageViewport_1yvje_91", c = {
  textContainer: e,
  closeButton: t,
  inverted: o,
  root: n,
  leftIcon: s,
  is2Liner: _,
  alignTop: i,
  flashMessageViewport: r
};
export {
  i as alignTop,
  t as closeButton,
  c as default,
  r as flashMessageViewport,
  o as inverted,
  _ as is2Liner,
  s as leftIcon,
  n as root,
  e as textContainer
};
//# sourceMappingURL=index.es759.js.map
